/* eslint-disable indent */
import './filter-machines.scss';

export default () => {
  // Get all the options
  let options = $( 'select option' );

  let allFilters = [];

  // Loop through each option, get the value of the option. If there is any machine with the same value as the option, show the option, else hide it
  $( '.machines__item' ).each( function () {
    let machine = $( this );
    let filterValues = machine.data( 'filtervalues' );

    // Convert filterValues to a string if it is not already
    if ( typeof filterValues !== 'string' ) {
      filterValues = filterValues.toString();
    }

    // Split the string into an array
    let filterValuesArray = filterValues.split( '-' );

    // Loop through each value in the array
    filterValuesArray.forEach( function ( value ) {
      // Add it to allFilters array if it is not already there
      if ( !allFilters.includes( value ) ) {
        allFilters.push( value );
      }
    } );
  } );

  // Loop through all options and hide the ones that are not in the allFilters array
  options.each( function () {
    let option = $( this );
    let optionValue = option.val();

    if ( !allFilters.includes( optionValue ) ) {
      option.hide();
    }
  } );

  // Add an event listener to the select element
  $( '#selectFilters' ).on( 'change', function () {
    // Get the selected value
    let selectedValue = $( this ).val();
    let selectedValue22 = $( '#selectFilters3' ).val();

    // Loop through all the machines
    $( '.machines__item' ).each( function () {
      // Get the data-filtervalues attribute value
      let filterValues = $( this ).data( 'filtervalues' );

      // Convert filterValues to a string if it is not already
      if ( typeof filterValues !== 'string' ) {
        filterValues = filterValues.toString();
      }

      if ( selectedValue22 != '' ) {
        if (
          filterValues.includes( selectedValue ) &&
          filterValues.includes( selectedValue22 )
        ) {
          // Show the machine if the selected value is in the filterValues array
          $( this ).show();
        } else {
          // Hide the machine if the selected value is not in the filterValues array
          $( this ).hide();
        }
      } else {
        // Check if selectedValue is a substring of filterValues
        if ( filterValues.includes( selectedValue ) ) {
          // Show the machine if the selected value is in the filterValues array
          $( this ).show();
        } else {
          // Hide the machine if the selected value is not in the filterValues array
          $( this ).hide();
        }
      }
    } );

    // If selectedValue != "", show select div with id selectFilters2
    if ( selectedValue != '' ) {
      $( '#selectFilters2' ).show();
      $( '#selectFilters2' ).val( '' );
      // Retrieve all currently visible machines
      let visibleMachines = $( '.machines__item:visible' );

      // Loop through each machine and get its data-filtervalues attribute value
      $( '#selectFilters2 option' ).hide();
      visibleMachines.each( function () {
        let filterValues = $( this ).data( 'filtervalues' );

        // Convert filterValues to a string if it is not already
        if ( typeof filterValues !== 'string' ) {
          filterValues = filterValues.toString();
        }
        // Split the string into an array
        let filterValuesArray = filterValues.split( '-' );

        // Make all options in selectFilters2 visible

        // Loop through each value in the array
        filterValuesArray.forEach( function ( value ) {
          // Check if the value has a matching option in the select element with id selectFilters2
          // If it does not, hide the option from the select element
          // Also hide the option with the from selectFilters2 that is selected in selectFilters
          // If it does, do nothing
          $( `#selectFilters2 option[value=${value}]` ).show();
        } );
        $( `#selectFilters2 option[value=${selectedValue}]` ).hide();
      } );
    } else {
      $( '#selectFilters2' ).hide();
    }
  } );

  // Add an event listener to the select element with id selectFilters2
  $( '#selectFilters2' ).on( 'change', function () {
    // Get the selected value
    let selectedValue3 = $( '#selectFilters' ).val();
    let selectedValue8 = $( '#selectFilters3' ).val();
    let selectedValue4 = $( this ).val();

    // Loop through all the machines
    $( '.machines__item' ).each( function () {
      // Get the data-filtervalues attribute value
      let filterValues = $( this ).data( 'filtervalues' );

      // Convert filterValues to a string if it is not already
      if ( typeof filterValues !== 'string' ) {
        filterValues = filterValues.toString();
      }

      // Check if selectedValue is a substring of filterValues
      if (
        filterValues.includes( selectedValue3 ) &&
        filterValues.includes( selectedValue4 ) &&
        filterValues.includes( selectedValue8 )
      ) {
        // Show the machine if the selected value is in the filterValues array
        $( this ).show();
      } else {
        // Hide the machine if the selected value is not in the filterValues array
        $( this ).hide();
      }
    } );
  } );
  // Add an event listener to the select element with id selectFilters2
  $( '#selectFilters3' ).on( 'change', function () {
    // Get the selected value
    let selectedValue5 = $( '#selectFilters' ).val();
    let selectedValue6 = $( '#selectFilters2' ).val();
    let selectedValue7 = $( this ).val();

    // Loop through all the machines
    $( '.machines__item' ).each( function () {
      // Get the data-filtervalues attribute value
      let filterValues = $( this ).data( 'filtervalues' );

      // Convert filterValues to a string if it is not already
      if ( typeof filterValues !== 'string' ) {
        filterValues = filterValues.toString();
      }

      // Check if selectedValue is a substring of filterValues
      if (
        filterValues.includes( selectedValue5 ) &&
        filterValues.includes( selectedValue6 ) &&
        filterValues.includes( selectedValue7 )
      ) {
        // Show the machine if the selected value is in the filterValues array
        $( this ).show();
      } else {
        // Hide the machine if the selected value is not in the filterValues array
        $( this ).hide();
      }
    } );

    let selectedValue20 = $( this ).val();

    // If selectedValue != "", show select div with id selectFilters2
    if ( selectedValue20 != '' ) {
      // Retrieve all currently visible machines
      let visibleMachines = $( '.machines__item:visible' );

      // Loop through each machine and get its data-filtervalues attribute value
      $( '#selectFilters option' ).hide();
      $( '#selectFilters2 option' ).hide();
      visibleMachines.each( function () {
        let filterValues = $( this ).data( 'filtervalues' );

        // Convert filterValues to a string if it is not already
        if ( typeof filterValues !== 'string' ) {
          filterValues = filterValues.toString();
        }
        // Split the string into an array
        let filterValuesArray = filterValues.split( '-' );

        // Make all options in selectFilters2 visible

        // Loop through each value in the array
        filterValuesArray.forEach( function ( value ) {
          // Check if the value has a matching option in the select element with id selectFilters2
          // If it does not, hide the option from the select element
          // Also hide the option with the from selectFilters2 that is selected in selectFilters
          // If it does, do nothing
          $( `#selectFilters option[value=${value}]` ).show();
          $( `#selectFilters2 option[value=${value}]` ).show();
        } );
        $( `#selectFilters option[value=${selectedValue20}]` ).hide();
        $( `#selectFilters2 option[value=${selectedValue20}]` ).hide();
      } );
    }
  } );
  // When pressing button with id resetButton, reset the select element to its default value (the first option) and show all the machines
  $( '#resetButton' ).on( 'click', function () {
    $( '#selectFilters' ).val( '' );
    $( '#selectFilters3' ).val( '' );
    $( '.machines__item' ).show();
    $( '#selectFilters2' ).hide();
  } );
};
